import { Box, styled } from '@mui/material';

export const StyledCopyFields = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(1)
}));

/**
 * Its own bar rather than MUI's DialogActions: the shared Dialog strips that one's side padding, which
 * put the primary button against the edge.
 */
export const StyledCopyActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  padding: theme.spacing(2, 3)
}));
